import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { trpc } from '../lib/trpc.js';
import { Logo } from '../componentes/Logo.js';

export function Login() {
  const navegar = useNavigate();
  const utils = trpc.useUtils();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  const entrar = trpc.auth.entrar.useMutation({
    onSuccess: async () => {
      // O cookie novo muda o resultado de todas as queries, inclusive auth.eu.
      await utils.invalidate();
      navegar('/', { replace: true });
    },
  });

  function enviar(e: FormEvent) {
    e.preventDefault();
    entrar.mutate({ email: email.trim(), senha });
  }

  return (
    <div className="login">
      <form onSubmit={enviar}>
        <div className="login-marca">
          <Logo />
        </div>
        <h1>Raio-X Fiscal</h1>
        <p className="lead">Entre com o e-mail do escritório para ver os documentos da empresa.</p>

        <label htmlFor="email">E-mail</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="senha">Senha</label>
        <input
          id="senha"
          type="password"
          autoComplete="current-password"
          required
          minLength={8}
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />

        <button type="submit" className="btn primary" disabled={entrar.isPending}>
          {entrar.isPending ? 'Entrando…' : 'Entrar'}
        </button>

        {entrar.error ? (
          <p className="erro" role="alert">
            {entrar.error.message}
          </p>
        ) : null}
      </form>
    </div>
  );
}
